import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--fd-colors-background-surface);
`;

export const PlayerWrapper = styled.div<{ height: number }>`
  position: relative;
  background-color: var(--fd-colors-core-black);
  overflow: hidden;
  height: ${({ height }) => `${height}px`};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background-color: transparent;
  padding: var(--fd-space-space-4);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--fd-space-space-3);
  padding: var(--fd-space-space-3);
  background-color: var(--fd-colors-background-surface);
`;

export const Description = styled.p`
  color: var(--fd-colors-content-strong);
  font-family: var(--fd-fonts-font-family-010), system-ui;
  font-size: var(--fd-font-sizes-font-size-040);
  line-height: var(--fd-line-heights-line-height-030);
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--fd-space-space-2);
`;
